export default __webpack_public_path__ + "static/media/bmwMini.28014dbe.gif";